import { createFeature, createReducer, on } from "@ngrx/store";
import { ClassroomPresenceActions } from "./classroom-presence.actions";
import { ClassroomPresenceUser } from "../models/classroom-presence-user";

export const classroomPresenceFeatureKey = 'classroomPresence';

export interface State {
    clients: ClassroomPresenceUser[];
}

export const initialState: State = {
    clients: [],
};

export const reducer = createReducer(
    initialState,
    // on(ClassroomPresenceActions.loadClassroomPresence, state => state),
    on(ClassroomPresenceActions.loadClassroomPresenceSuccess, (state, { clients }): State => ({
        ...state,
        clients,
    })),

    on(ClassroomPresenceActions.userDisconnected, (state, { client }) => {
        const idx = state.clients.findIndex(c => c.connectionId === client.connectionId);

        if (idx >= 0) {
            const clients = [...state.clients];
            clients.splice(idx, 1, client);

            return {
                ...state,
                clients,
            }
        }

        return state;
    }),
    on(ClassroomPresenceActions.userConnected, (state, { client }) => ({
        ...state,
        clients: addOrUpdateClient(state.clients, client),
    })),

    on(ClassroomPresenceActions.pingUserSuccess, (state, { client, isOnline }) => {
        if (!isOnline) {
            const idx = state.clients.findIndex(c => c.connectionId === client.connectionId);

            if (idx >= 0) {
                const clients = [...state.clients];
                clients.splice(idx, 1);

                return {
                    ...state,
                    clients,
                }
            }
        }

        return state;
    }),
);

export const classroomPresenceFeature = createFeature({
    name: classroomPresenceFeatureKey,
    reducer,
});

const addOrUpdateClient = (clients: ClassroomPresenceUser[], client: ClassroomPresenceUser) => {
    const idx = clients.findIndex(c => c.connectionId === client.connectionId);

    if (idx >= 0) {
        const updated = [...clients];
        updated.splice(idx, 1, client);
        return updated;
    }

    return [...clients, client];
};
